<template>

    <FloatingPanel>

        <div class="canvas-blocks-common-singleRow-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Opmaak',
            ]">

                <div slot="Algemeen">

                    <ColorsInput 
                        label="Achtergrondkleur card"
                        :colors="colors"
                        :options="options"
                        options-property="cardColor"
                        :open="true"
                    />

                </div>

                <div slot="Opmaak">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        ColorsInput,
    },


    data: function () {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors()).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);
        },

    },

}

</script>